// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Y3kb","buttons":"Footer_buttons__2CfXl"};